// @flow
import React from 'react'
import styled from 'styled-components'
import Dropdown from 'components/Dropdown'
import * as cf from 'cf'

import alertStore from 'stores/alert'

type State = {
  locale: string
}

export default class CopyAllComponents extends React.Component<{}, State> {

    state = {
        locale: ''
    }

    handleLocaleChange = (locale:*) => this.setState({locale})
    
    handleButtonClick = () => {
        if(!this.state.locale) return
        alertStore.set({
            title: `Klonen (${this.state.locale})`,
            body: `Du bist kurz davor den Inhalt von der Sprache "${this.state.locale}" zu klonen.
            Damit werden alle Inhalte in diesem Feld überschrieben. Aller Komponenten die nicht in ${this.state.locale}
            vorhanden sind oder in einer anderen Form vorhanden sind werden gelöscht. Bitte nur ausführen, wenn du weißt was du tust ;)`,
            onOk: () => cf.cloneLocale(this.state.locale)
        })
    }

    render(){
        return (
            <Wrapper>
                <Dropdown 
                    placeholder='locale'
                    values={cf.getLocales()}
                    value={this.state.locale}
                    onChange={this.handleLocaleChange}
                />
                <Button className="Button" onClick={this.handleButtonClick}>Copy</Button>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    display: flex;
    > .Dropdown { flex: 2; margin-right: 5px; }
    > .Button { flex: 1; }
`

const Button = styled.div`
    background: rgb(0, 150, 136);
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/config/CopyAllComponents.js